import React, { Component } from 'react'
import Input from './components/input'
import Range from './components/range'
import Results from './components/results'

import './newsStyle.css'

//import formatMoney from './helpers/format-money/'
import formatYears from './helpers/format-years/'

class App extends Component {
    constructor(props) {
        super(props)

        /* API URL */
        let apiUrl = document.getElementById('root').getAttribute('data-api-url')
        if (!apiUrl) {
            console.error('API URL is not defined as "data-api-url" attribute in "#root".')
        }
        let emojiUrl = document.getElementById('emoji').getAttribute('data-emoji') || null;
        if (!emojiUrl) { console.error('API URL is not defined as "data-emoji" attribute in "#emoji".'); }

        let credits = []
        // let citizenshipList = []
        let programList = ['Все программы'];
        let firstFeePercentArray = []
        let creditMinLengthArray = []

        // this.getDataFromServer(apiUrl, data => {
        this.getDataFromServerNew(apiUrl, data => {
            data.data.forEach((credit, i) => {
              // const availableCitizenship = this.getCitizenshipList(credit.citizenships);
              const availableProgram = this.getProgramList(credit.mortgagePrograms);

              credits.push({
                title: credit.bank.name,
                // availableCitizenship: availableCitizenship,
                availableProgram: availableProgram,
                // age: {
                //   min: credit.age_min,
                //   max: credit.age_max
                // },
                creditLength: {
                  min: credit.credit_term_min,
                  max: credit.credit_term_max
                },
                maxSum: credit.max_summ,
                percent: credit.percent,
                minFirstFeePercent: credit.initial_fee_min_percent,
                img: credit.bank.image,

                imgWhite: credit.bank.white_image,
                backgroundColor: credit.bank.background_color,

                // subsidizing: credit.is_subsidizing,
                subsidizingSupport: credit.is_subsidizing,
                mortgagePrograms: credit.mortgagePrograms,
                disclaimer: credit.disclaimer,

                stateSupport: credit.is_state_support,
                isSubsidizing: credit.is_subsidizing,
                // id: i
                id: credit.bank.id
              });

              // availableCitizenship.forEach(citizenship => {
              //   if (citizenshipList.indexOf(citizenship) === -1){
              //     citizenshipList.push(citizenship)
              //   }
              // });

              availableProgram.forEach(program => {
                if (programList.indexOf(program) === -1){
                  programList.push(program)
                }
              });
            });

            credits.forEach(credit => {
              if (credit.creditLength.max > defaultProps.creditLengthMax){
                defaultProps.creditLengthMax = credit.creditLength.max
              }
              // if (credit.age.max > defaultProps.ageMax){
              //   defaultProps.ageMax = credit.age.max
              // }

              firstFeePercentArray.push(credit.minFirstFeePercent);
              creditMinLengthArray.push(credit.creditLength.min)
            });

            this.setState({
              credits: credits,
              // citizenshipList: citizenshipList,
              programList: programList,
              // subsidizingList: subsidizingList,
              mostFrequentFirstFeePercent: this.findMostFrequentInArray(firstFeePercentArray),
              mostFrequentMinCreditLength: this.findMostFrequentInArray(creditMinLengthArray),
            })
          }, 'ru');

        const urlData = this.parseURL(window.location.href)

        let defaultProps = {
            maxPrice: 200000000,
            creditSum: urlData && urlData.creditSum ? urlData.creditSum : 57000000,

            creditLengthMin: 0,
            creditLengthMax: 30,

            // ageMin: 18,
            // ageMax: 80,
            // age: 30,

            credits: credits,

            firstFeePercent: 31,
            maxFirstFeePercent: 90,

            citizenship: 'РФ',

            program: 'Все программы',
            programAll: 'Все программы',

            stateSupport: 0,
            subsidizingSupport: 0,
            isSubsidizing: 0,

            email: '',
            emojiUrl:emojiUrl,
        };

        defaultProps.firstFee = (defaultProps.creditSum / 100) * defaultProps.firstFeePercent
        defaultProps.maxFirstFee = Math.round(
            (defaultProps.creditSum / 100) * defaultProps.maxFirstFeePercent,
        )

        defaultProps.creditLength = Math.floor(
            (defaultProps.creditLengthMax + defaultProps.creditLengthMin) / 2,
        )

        this.state = defaultProps
    }

    getDataFromServer = (url, callback, lang) => {
        const httpRequest = new XMLHttpRequest()

        httpRequest.onreadystatechange = () => {
            if (httpRequest.readyState === 4 && httpRequest.status === 200) {
                callback(JSON.parse(httpRequest.responseText))
            }
        }

        httpRequest.open('get', url, true)
        httpRequest.setRequestHeader('Accept-Language', lang)
        httpRequest.send()
    }

    getDataFromServerNew = async (url, callback, lang) => {
        try {
          const response = await fetch(url, {
            method: 'GET',
            headers: {
              'Accept-Language': lang,
            }
          });
          const res = await response.json();
          let nextLink = res.links.next ? res.links.next : false;

          while (nextLink) {
              const responseCustom = await fetch(res.links.next,{
                method: 'GET',
                headers: {
                  'Accept-Language': lang,
                }
              });
              const resCustom = await responseCustom.json();

              nextLink = resCustom.data.next ? resCustom.data.next : false;

              res.data.push(...resCustom.data)
              res.links = resCustom.links;
              res.meta = resCustom.meta;
          }

          callback(res);
        } catch (error) {
          console.log(error)
        }
    };

    parseURL = url => {
        const data = {}

        url = url.slice(url.indexOf('?') + 1, url.length + 1).split('&')

        url.forEach(item => {
            item = item.split('=')
            data[item[0]] = Number(item[1])
        })

        return data
    }

    // getCitizenshipList = arr => {
    //     let citizenshipList = []
    //     arr.forEach(item => {
    //         citizenshipList.push(item.name)
    //     })
    //     return citizenshipList
    // }

    getProgramList = (arr) => {
        let programList = [];
        arr.forEach(item => {
          programList.push(item.name)
        });
        return programList
    };

    findMostFrequentInArray = array => {
        if (!array.length) return
        let reduced = array.reduce((reduced, number) => {
            if (number in reduced) {
                reduced[number]++
            } else {
                reduced[number] = 1
            }

            return reduced
        }, {})

        return Object.keys(reduced).reduce((a, b) => (reduced[a] >= reduced[b] ? a : b))
    }

    handleChange = (prop, value) => {
        if (typeof value === 'object') {
            value = value.target.value
        }
        this.setState({
            [prop]: value,
        })
    }

    changeCreditSum = value => {
        if (value < Math.round((this.state.firstFee / 9) * 10)) {
            this.setState({
                firstFee: this.calcMaxFirstFee(value),
            })
        }
        this.setState({
            creditSum: value,
            maxFirstFee: this.calcMaxFirstFee(value),
            firstFeePercent: this.calcFirstFeePercent(),
        })
    }

    changeSubsidizingSupport = value => {
        this.setState({
          subsidizingSupport: value,
        });
    };

    changeFirstFee = value => {
        this.setState({
            firstFee: value,
            firstFeePercent: this.calcFirstFeePercent(),
        })
    }

    calcMaxFirstFee = value => Math.round((value / 10) * 9)

    calcFirstFeePercent = () => {
        const result = Math.round(this.state.firstFee / (this.state.creditSum / 100))
        return isNaN(result) || result === Infinity ? 0 : result
    }

    banksListTransform = (banksList) => {
        let newBanksList = banksList.map((item => {
          const { id, title, img, imgWhite, backgroundColor, ...rest } = item;

          return ({
            id,
            name: title,
            image: img,
            imageWhite: imgWhite,
            backgroundColor: backgroundColor,
            ...rest,
          })
        }));

        const prepare = (arr) => {
          const newArr = [];

          arr.forEach(obj1 => {
            const { id, name, image, imageWhite, backgroundColor, ...rest } = obj1;

            const found = newArr.find((obj2) => obj1.id === obj2.id);
            const foundIndex = newArr.findIndex((obj2) => obj1.id === obj2.id);

            if(found) {
              newArr[foundIndex].spisok = [...newArr[foundIndex].spisok,{
                ...rest
              }];

              return;
            } else {
              newArr.push({
                id,
                name,
                image,
                imageWhite,
                backgroundColor,
                spisok: [{
                  ...rest
                }]
              })
            }
          });

          return newArr;
        }

        const prepared = prepare(newBanksList);
        return prepared;
    }

    filterCredits = () => {
        const formData = this.state
        let { credits } = this.state

        let disabledCredits = []

        credits = credits.filter(credit => {
            if (
                // credit.availableCitizenship.indexOf(formData.citizenship) !== -1 &&
                ((formData.programAll === formData.program) ? credit.availableProgram : credit.availableProgram.indexOf(formData.program) !== -1 )
                // ((formData.programAll === formData.program) ? credit.availableProgram : credit.availableProgram.indexOf(formData.program) !== -1 ) &&
                // credit.age.min <= formData.age &&
                // credit.age.max >= formData.age
            ){
                if (
                    credit.creditLength.min <= formData.creditLength &&
                    credit.creditLength.max >=  formData.creditLength &&
                    ((!isNaN(+credit.maxSum) && +credit.maxSum  >= formData.creditSum ) || credit.maxSum==null || credit.maxSum==='неограничена') &&
                    credit.minFirstFeePercent <= formData.firstFeePercent
                  ){
                    if(formData.subsidizingSupport) {
                        return (Boolean(credit.subsidizingSupport) === true)
                    } else {
                        return credit
                    }
                } else {
                    disabledCredits.push(credit)
                    return null
                }
            } else return null
        })

        let smallestPercent = Infinity

        credits.forEach(credit => {
            const percentPerMonth = credit.percent / 100 / 12
            const monthsToPay = formData.creditLength * 12
            const creditTotal = formData.creditSum - formData.firstFee

            credit.payPerMonth = this.calculatePayPerMonth(
                percentPerMonth,
                monthsToPay,
                creditTotal,
            )

            if (credit.percent < smallestPercent) {
                smallestPercent = credit.percent
            }
        })

        // let bestCredits = [];
        // let otherCredits = [];

        // credits.forEach(credit => {
        //   if (credit.percent === smallestPercent){
        //     bestCredits.push(credit);
        //   } else {
        //     otherCredits.push(credit);
        //   }
        // });

        // if (otherCredits.length){
        //   this.sortArr(otherCredits, 'percent')
        // }

        if (credits.length){
            this.sortArr(credits, 'payPerMonth');
        }

        if (disabledCredits.length) {
            this.sortArr(disabledCredits, 'minFirstFeePercent')
            disabledCredits = disabledCredits.slice(0, 3)
        }

        return {
            best: credits,
            newBest: this.banksListTransform(credits),
            other: [],
            disabled: disabledCredits
          }
    }

    calculatePayPerMonth = (percentPerMonth, monthsToPay, creditSum) => {
        const presentValueInterestFactor = Math.pow(1 + percentPerMonth, monthsToPay)
        return (
            (percentPerMonth / (presentValueInterestFactor - 1)) *
            creditSum *
            presentValueInterestFactor
        )
    }

    sortArr = (arr, prop) => {
        return arr.sort((a, b) => {
            return a[prop] - b[prop]
        })
    }

    renderPreloader = () => {
        return (
            <div className="preloader">
                <div className="preloader__wrapper">
                    <div className="preloader__spinner"></div>
                </div>
            </div>
        )
    }

    getProperScrollDestination = dest => dest - 0

    handlePick = credit => {
        this.setState({
            pickedCredit: credit,
        })
    }

    handleSubmit = pickedCredit => {
        //alert(JSON.stringify(pickedCredit))
        this.setState({
            sending: true,
        })
        setTimeout(() => {
            this.setState({
                sending: false,
                sendSuccess: true,
            })
        }, 1000)
    }

    hideBanner = () => {
        this.setState({
            sendSuccess: false,
        })
    }

    checkIfPickedCreditInResults = (results, pickedCredit) =>
        results.indexOf(pickedCredit) !== -1 ? true : false

    render() {
        const {
            credits,

            programList,
            subsidizingSupport,

            creditSum,
            maxPrice,
            firstFee,
            maxFirstFee,
            firstFeePercent,
            mostFrequentFirstFeePercent,
            creditLength,
            creditLengthMax,
            creditLengthMin,
            mostFrequentMinCreditLength,
            pickedCredit,
            emojiUrl
        } = this.state

        // if (!credits.length) {
        //     return this.renderPreloader()
        // }

        const results = this.filterCredits()

        return (
            <div className="app" ref="app">
                <div className="filter-section">
                    <div className="filter-section__row">
                        <div className="filter-section__left">
                            <h3>Ипотечный калькулятор</h3>
                            <form
                                className="form"
                                onSubmit={e => {
                                    e.preventDefault()
                                }}
                            >
                                <div className='filter-input'>
                                    <Input
                                        type="select"
                                        // label="Все программы"
                                        label=""
                                        value={programList}
                                        onChange={this.handleChange.bind(this, 'program')}
                                        // onChange={this.handleSelectChange.bind(this, 'program')}
                                    />
                                </div>
                                <div className='filter-input'>
                                    <Input
                                        type="checkbox"
                                        label="Субсидирование"
                                        value={subsidizingSupport}
                                        onChange={this.changeSubsidizingSupport.bind(this,!subsidizingSupport)}
                                    />
                                </div>
                                <Range
                                    label="Стоимость квартиры, ₽"
                                    value={creditSum}
                                    min={0}
                                    max={maxPrice}
                                    onChange={this.changeCreditSum.bind(this)}
                                    isMoney={true}
                                    from="1 млн"
                                    to="200 млн"
                                />
                                <Range
                                    label="Первоначальный взнос, ₽"
                                    value={firstFee}
                                    min={0}
                                    max={maxFirstFee}
                                    from="500 тыс."
                                    to="180 млн"
                                    onChange={this.changeFirstFee.bind(this)}
                                    isMoney={true}
                                    tip={
                                        firstFeePercent < mostFrequentFirstFeePercent &&
                                        `У большинства кредитов первоначальный взнос более ${mostFrequentFirstFeePercent}%`
                                    }
                                    error={firstFeePercent < mostFrequentFirstFeePercent}
                                />

                                <Range
                                    label="Срок кредита, лет"
                                    value={creditLength}
                                    min={creditLengthMin}
                                    max={creditLengthMax}
                                    from={`от ${creditLengthMin + 1}`}
                                    to={`до ${creditLengthMax}`}
                                    onChange={this.handleChange.bind(this, 'creditLength')}
                                    tip={
                                        creditLength < mostFrequentMinCreditLength &&
                                        `У большинства кредитов минимальный срок: ${formatYears(
                                            mostFrequentMinCreditLength,
                                        )}`
                                    }
                                    error={creditLength < mostFrequentMinCreditLength}
                                />
                                {this.checkIfPickedCreditInResults(
                                    [...results.best, ...results.other],
                                    pickedCredit,
                                ) && (
                                    <input
                                        type="submit"
                                        value="Отправить на почту"
                                        className="button"
                                    />
                                )}
                                <div className="filter-section__submit mob">
                                    <button type="button" className="but but_white js-filterApply">
                                        <div className="but__text">Применить</div>
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div className="filter-section__right" ref="results">
                            <h2 className="subtitle">Предложения банков</h2>
                            <button className="but but_white mob js-filterMortgage">
                                <div className="but__icon">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                    >
                                        <rect width="24" height="24" fill="none" />
                                        <path
                                            d="M4,.5H0v-1H4Z"
                                            transform="translate(1.894 7)"
                                            fill="#fff"
                                        />
                                        <path
                                            d="M4,.5H0v-1H4Z"
                                            transform="translate(17.894 17)"
                                            fill="#fff"
                                        />
                                        <path
                                            d="M10,.5H0v-1H10Z"
                                            transform="translate(11.894 7)"
                                            fill="#fff"
                                        />
                                        <path
                                            d="M10,.5H0v-1H10Z"
                                            transform="translate(1.894 17)"
                                            fill="#fff"
                                        />
                                        <path
                                            d="M3-.5A3.5,3.5,0,1,1-.5,3,3.5,3.5,0,0,1,3-.5Zm0,6A2.5,2.5,0,1,0,.5,3,2.5,2.5,0,0,0,3,5.5Z"
                                            transform="translate(6 4)"
                                            fill="#fff"
                                        />
                                        <path
                                            d="M3-.5A3.5,3.5,0,1,1-.5,3,3.5,3.5,0,0,1,3-.5Zm0,6A2.5,2.5,0,1,0,.5,3,2.5,2.5,0,0,0,3,5.5Z"
                                            transform="translate(12 14)"
                                            fill="#fff"
                                        />
                                    </svg>
                                </div>
                                <div className="but__text">
                                    Фильтры ({results.other.length + results.best.length})
                                </div>
                            </button>
                            {/* <div className="mortgage-head">
                                <div className="mortgage-head__item">Банк</div>
                                <div className="mortgage-head__item">Процентная ставка</div>
                                <div className="mortgage-head__item">Ежемесячный платеж</div>
                                <div className="mortgage-head__item">Срок до</div>
                            </div> */}
                            <Results
                                credits={results}
                                handlePick={this.handlePick}
                                pickedCredit={pickedCredit}
                                emoji={emojiUrl}
                            />

                            <div className="disclaim">
                                <p>
                                    Размещенные данные носят информационный характер и не являются публичной офертой. Подробную информацию об условиях предоставления ипотеки вы можете узнать по телефону.
                                </p>
                            </div>
                            {/* <div className="disclaim">
                                <p>
                                    <span>*</span> Ставка&nbsp;0,1% годовых действует
                                    в&nbsp;течение&nbsp;12 (Двенадцати) месяцев с&nbsp;даты
                                    заключения кредитного договора в случае оформления полного
                                    комплексного страхования и первоначальном взносе не&nbsp;менее
                                    20%. Ставка&nbsp;0,1% годовых обеспечивается за&nbsp;счет
                                    субсидирования из&nbsp;средств Застройщика Компания
                                    с&nbsp;ограниченной ответственностью &laquo;ЛИСАРИО ТРЕЙДИНГ
                                    ЛИМИТЕД&raquo;. По&nbsp;истечении&nbsp;12 (Двенадцати) месяцев
                                    процентная ставка в&nbsp;рублях&nbsp;РФ составит 10,8% годовых.
                                    Программа распространяется на&nbsp;покупку строящегося
                                    и&nbsp;готового жилья. Сумма кредита до&nbsp;60 млн.руб. Валюта
                                    кредита&nbsp;&mdash; рубли. Срок кредита&nbsp;&mdash;
                                    от&nbsp;1&nbsp;до&nbsp;30&nbsp;лет. При отсутствии комплексного
                                    страхования ставка по&nbsp;кредиту увеличивается на&nbsp;1%.
                                    <span>*</span> Ставка 0,3% годовых действует в течение 12 (Двенадцати) месяцев с даты заключения кредитного договора в случае оформления полного комплексного страхования и первоначальном взносе не менее 20%. Ставка 0,3% годовых обеспечивается за счет субсидирования из средств Застройщика Компания с ограниченной ответственностью «ЛИСАРИО ТРЕЙДИНГ ЛИМИТЕД». По истечении 12 (Двенадцати) месяцев процентная ставка в рублях РФ составит 10,4% годовых, с учетом дисконта 0,3% при использовании дистанционных каналов, к базовой ставке в размере 10,7% годовых. Программа распространяется на покупку строящегося и готового жилья. Сумма кредита до 60 млн.руб. Валюта кредита – рубли. Срок кредита – от 1 до 30 лет. При отсутствии комплексного страхования ставка по кредиту увеличивается на 1%.
                                </p>
                                <p>Условия действительны на&nbsp;10.10.2022&nbsp;г.</p>
                                <p>
                                    Банк ВТБ (ПАО) оказывает исключительно банковские услуги. Банк
                                    вправе отказать в&nbsp;предоставлении кредита без объяснения
                                    причин. Банк предоставляет кредит в&nbsp;случае, если заемщик
                                    (созаемщик/поручитель, при наличии) соответствуют требованиям
                                    Банка и&nbsp;предоставили полный пакет необходимых документов.
                                </p>
                                <p>
                                    Банк ВТБ (ПАО). Генеральная лицензия Банка России
                                    &#8470;&nbsp;1000. Реклама.
                                </p>
                                <p>
                                    <span>*</span> Предложение действует на&nbsp;ограниченный пул
                                    апартаментов.
                                </p>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default App

// WEBPACK FOOTER //
// ./src/App.js
